import React, { Component } from 'react';

import { achievement_map } from '../AchievementInfo';
import random_id from '../random_id';

function map_achievement(id) {
	const a = achievement_map[id];
	if (a) {
		return [a.title, a.desc];
	} else {
		return [a.id, "FIXME"];
	}
}

class Achievement extends Component {
	constructor(props) {
		super(props);
		this.state = { show_tooltip: false, rid: random_id() };
	}

	render() {
		const is_earned = this.props.is_earned === undefined ? true : this.props.is_earned;

		var classes = "ad_achievement_box ad_achievement_box_width pt-4 ";
		var achieved_img;

		classes += is_earned ? "ad_achievement_earned" : "ad_achievement_not_earned";

		const [title, desc] = map_achievement(this.props.id);

		const img_pre = "/gfx/achievements/";

		if(is_earned) {
			achieved_img = img_pre + this.props.id + "-won-0.svg";
		} else {
			achieved_img = img_pre + this.props.id + "-notwon-0.svg";
		}

		return (
			<div className={classes} id={this.state.rid}>
				<div className="ad_achievement_img text-center pt-5 pb-4">
					<img alt={this.props.id} src={achieved_img}/>
				</div>
				<div className="text-center pb-3"><b>{title}</b></div>
				<div className="font-small ad_achievement_text px-3">{desc}</div>
			</div>
		);
	}
}

export default Achievement;



// WEBPACK FOOTER //
// ./src/c/Achievement.js